import React from 'react';

export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.5 3L15.5 15" stroke="#6F3FD7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.5 3L3.5 15" stroke="#6F3FD7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
